/* eslint-disable react/no-array-index-key */
import { Container, Row, Col } from 'react-bootstrap';
import ArticleWithShortDesc from '../../../Components/articleWithShortDesc/ArticleWithShortDesc';
import { SubSectionHeading } from '../../../Components/Headings';
import articleImageLarge from '../../../assets/images/png/article-large.png';
import articleImage1 from '../../../assets/images/png/article1.png';
import articleImage2 from '../../../assets/images/png/article2.png';
import articleImage3 from '../../../assets/images/png/article3.png';
import ArticleItemLists from '../../../Components/articleItemLists/ArticleItemLists';
import './topReads.css';

const articlesData = [
  {
    image: articleImage1,
    status: [
      {
        statusText: 'تصدیق شدہ',
        statusProgress: 'verified'
      },
      {
        statusText: 'حقیقت کی جانچ پڑتال',
        statusProgress: 'fact'
      }
    ],
    topic: 'اپنے گھر میں زیادہ سے زیادہ محفوظ بنائیں',
    topicDesc: '',
    btnText: 'مزید پڑھ',
    link: '/ArticleInnerPage'
  },
  {
    image: articleImage2,

    status: [
      {
        statusText: 'حقیقت کی جانچ پڑتال',
        statusProgress: 'fact'
      }
    ],
    topic: 'ایڈیٹر کی طرف سے ایک خط',
    topicDesc: '',
    btnText: 'مزید پڑھ',
    link: '/ArticleInnerPage'
  },
  {
    image: articleImage3,

    status: [
      {
        statusText: '',
        statusProgress: ''
      }
    ],
    topic: 'اپنے گھر میں زیادہ سے زیادہ محفوظ بنائیں',
    topicDesc: '',
    btnText: 'مزید پڑھ',
    link: '/ArticleInnerPage'
  }
];

function TopReads() {
  return (
    <section className="top_reads article">
      <Container>
        <SubSectionHeading text="مزید ٹاپ ریڈز" />
        <Row>
          <Col md={7} className="pe-lg-0">
            <ArticleWithShortDesc
              image={articleImageLarge}
              topic="اپنے گھر پر موسم گرما کا زیادہ سے زیادہ فائدہ اٹھائیں۔"
              desc="چونکہ ہمیں مسلسل سماجی دوری اور گھر میں محفوظ رہنما خطوط کا سامنا ہے، یہاں آپ کے خاندان کو متحرک رکھنے کے کچھ تخلیقی طریقے ہیں
              "
              btnText="مزید پڑھ"
            />
          </Col>
          <Col md={5}>
            {articlesData.map((article, index) => {
              const { image, topic, topicDesc, btnText, link } = article;
              return (
                <ArticleItemLists
                  key={index}
                  status={article.status}
                  leftCol={5}
                  rightCol={7}
                  image={image}
                  heading={topic}
                  desc={topicDesc}
                  btnText={btnText}
                  link={link}
                />
              );
            })}
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default TopReads;
